<template>
  <div>
    <!-- HEADER -->
    <form-header
        :show-save-edit="false"
        :show-toolbox="true"
        v-if="showHeader"
        :toolbox="toolbox">
      <!-- Left side button - primary actions -->
      <template v-slot:primaryButton>
        <slot name="primaryButton"></slot>
      </template>

      <!-- toolbars -->
      <template v-slot:toolButtons>
        <headers-button-group>
          <slot name="toolButtons"></slot>
        </headers-button-group>
      </template>

      <!-- danger actions on the right -->
      <template v-slot:dangerButton>
        <slot name="dangerButton"></slot>
      </template>

      <template
          v-slot:additionalHeaderRows>
        <slot name="additionalHeaderRows"></slot>
      </template>

    </form-header>
    <!-- HEADER END-->


    <v-box ref="vbox" :scrollable="true">
      <!-- CONTENT -->
      <slot>

      </slot>
      <!-- CONTENT END-->
    </v-box>

    <slot name="bottomLine"></slot>
    <!-- FOOTER -->
    <footer-navbar>

      <close-button @close="close" :readOnly="!closeIsCancel" v-if="showCloseButton"></close-button>
      <slot name="footer"></slot>
    </footer-navbar>
    <!-- FOOTER END -->
  </div>
</template>

<script>
import FormHeader from "@/components/forms/FormHeader";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterButton from "@/components/navbar/FooterButton";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import CloseButton from "@/components/navbar/CloseButton";

let x = FormHeader;
export default {
  name: "SimpleActivity",
  components: {CloseButton, VBox, FooterNavbar, FooterButton, HeadersButtonGroup, FormHeader},
  created() {

  },
  props: {
    showHeader: {default: true},
    closeIsCancel: {default: false},
    showCloseButton: {
      default: true
    },
    toolbox: {default: null}
  },
  methods: {
    isLayout() {
      return true;
    },
    close() {
      ActivityManager.findActivity(this.$el).close();
    }
  },
}
</script>

<style scoped>

</style>